import type { Payment } from 'paintscout'

/** A Payrix ACH/EFT payment that is still processing can be canceled until the txn settles. */
export function canCancelProcessingPayment(payment: Payment): boolean {
  if (!payment?.activityId || payment.manual) return false
  if (payment.provider !== 'payrix' || payment.status !== 'processing') return false
  return ['ach', 'eft'].includes(payment.type?.toLowerCase() ?? '')
}
